import React, { useState, useEffect, useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { AgGrid } from '../AgGrid';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { getOrdersColumnDefinitions } from '../../helpers';
import RequestNewOrdersButton from '../RequestNewOrdersButton';
import { BulkAssignDialog } from '../BulkAssignDialog';
import { AppContext } from '../../AppContext';
import { bulkAssignOrdersToQa } from '../../services';
import ROLES, { hasPermission } from '../../helpers/roles';

// SERVICES
import { getQaUserOptions } from '../../services';

const styles = theme => ({});

export const OrdersInFieldRepReview = withRouter(
  withStyles(styles)(props => {
    const {
      state: { roles },
    } = useContext(AppContext);

    const isAdmin = hasPermission([ROLES.ADMIN], roles);

    const { showCanceledOrdersOnly } = props;
    const columnDefinitions = getOrdersColumnDefinitions('fieldrep', 'admin', isAdmin);
    const [showGrid, setShowGrid] = useState(true);

    // const [showBulkEditDialog, setShowBulkEditDialog] = useState(false);
    // const [bulkEditRowData, setBulkEditRowData] = useState([]);
    // const [dialogValues, setDialogValues] = useState({
    //   qaId: null,
    // });
    // const [qaUserOptions, setQaUserOptions] = useState(null);

    const gridOptions = {
      // rowSelection: 'multiple',
    };

    /**
     * BULK ASSIGN LOGIC
     */
    // const openBulkEditDialog = rowData => {
    //   setBulkEditRowData(rowData.map(row => row.orderTicket).sort((a, b) => (a > b ? 1 : -1)));
    //   setShowBulkEditDialog(true);
    // };

    // const newOrdersCb = () => {
    //   setShowGrid(false);
    //   setTimeout(() => {
    //     setShowGrid(true);
    //   }, 0);
    // };

    // const getQaUserOptionsAsync = async () => {
    //   try {
    //     let qaList = await getQaUserOptions();
    //     setQaUserOptions(qaList);
    //   } catch (error) {
    //     console.log(error);
    //   }
    // };

    // useEffect(() => {
    //   getQaUserOptionsAsync();
    // }, []);

    return (
      <div className={classnames('flex-1', 'card', 'border-left-green', 'col-center-center')}>
        {showGrid && (
          <AgGrid
            gridData={[]}
            columnDefs={columnDefinitions}
            // handleCellClick={evt => props.history.push(`/orders/qa/${evt.data.orderTicket}`)}
            redirectOnClick={false}
            editOnClick={false}
            gridOptions={gridOptions}
            // openBulkEditDialog={isAdmin ? openBulkEditDialog : null}
            useDatasource={true}
            datasourceUrl={'/orders'}
            // gridName={showCanceledOrdersOnly ? 'QA_CLOSED_GRID' : 'QA_GRID'}
            gridName="FR_REVIEW"
            defaultFilters={
              [
                // {
                //   name: 'onHold',
                //   model: {
                //     filterType: 'text',
                //     type: 'notContains',
                //     filter: 'HOLD',
                //   },
                // },
              ]
            }
          />
        )}

        {/* <BulkAssignDialog
          {...props}
          onConfirm={bulkAssignOrdersToQa}
          rowData={bulkEditRowData || []}
          personOptions={qaUserOptions}
          personValueField={'qaId'}
          personPlaceholder={'Search for a QA rep'}
          show={showBulkEditDialog}
          setShow={setShowBulkEditDialog}
          dialogValues={dialogValues}
          setDialogValues={setDialogValues}
        /> */}
      </div>
    );
  }),
);

OrdersInFieldRepReview.propTypes = {};
